import type React from 'react';
import SvgIcon from './SvgIcon';

const SignDollarArrowSvg: React.FC = ({
  ariaLabel,
}:{
  ariaLabel?: string;
}) => (
  <SvgIcon
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    ariaLabel={ariaLabel}
  >
    <path
      d="M5.925 4.36C4.935 4.36 3.835 4.79 3.835 5.83C3.835 6.72161 4.88047 7.13648 6.1176 7.6274C7.90529 8.3368 10.0932 9.20501 10.105 11.9C10.105 13.95 8.535 15.46 6.585 15.85V18H4.265V15.83C2.925 15.57 1.685 14.92 0.625 13.93L2.325 12.15C3.095 13 4.275 13.64 5.515 13.64C6.675 13.64 7.485 12.93 7.485 11.94C7.485 10.7351 6.27653 10.259 4.92891 9.72819C4.3305 9.49248 3.70465 9.24595 3.145 8.92C2.075 8.3 1.225 7.37 1.225 5.84C1.225 3.97 2.575 2.69 4.245 2.23V0H6.565V2.09C7.615 2.21 8.615 2.57 9.625 3.31L8.265 5.25C7.725 4.75 6.815 4.36 5.925 4.36Z"
      fill="currentColor"
      fillOpacity="0.9"
    />
    <path
      d="M11.625 7.99677H16.2133L14.4208 6.20425L15.835 4.79004L19.335 8.29004C19.5226 8.47758 19.6279 8.73193 19.6279 8.99715C19.6279 9.26236 19.5226 9.51672 19.335 9.70425L15.835 13.2043L14.4208 11.79L16.2141 9.99677H11.625V7.99677Z"
      fill="currentColor"
      fillOpacity="0.9"
    />
  </SvgIcon>
);

export default SignDollarArrowSvg;
